
const GROUP_MODEL_RELATION = {
    Kickplates : ['Kickplates Paint Grip'],
    Decor: ['Decor Color'],
    'Food Guards' : ['Heat/Light'],
    Top: ['Top Backsplash', 'Top Extended']
};
export function getGroupModelMap() {
      
    const multipleModelMap = new Map();
    for (const [key, value] of Object.entries(GROUP_MODEL_RELATION)) {
        multipleModelMap.set(key, value);
    }

    return multipleModelMap;
}